import {
	CollectionType,
	type Collections,
	type Product,
	type ProductSelectOption,
} from '../../types';

export const getTwcProducts = (
	availableProducts: (ProductSelectOption | Product)[],
	productId?: string,
	jiraSubProduct?: string,
	collections: Collections = {},
): { isTwcPreselected: boolean; twcProducts: string[] } => {
	const products = availableProducts.map((product) =>
		'id' in product ? product.id : product.value,
	);

	const isTwcEnabled = collections[CollectionType.TEAMWORK_COLLECTION]?.isEnabled;
	const key = productId === 'jira' ? jiraSubProduct : productId;
	const twcProducts = collections[CollectionType.TEAMWORK_COLLECTION]?.products || [];
	const isTwcProduct = key && twcProducts.includes(key);

	if (isTwcEnabled && isTwcProduct && twcProducts.length) {
		const availableTwcProducts = products
			.filter((product) => twcProducts.includes(product))
			.sort((a, b) => {
				if (a === key) {
					return -1;
				}
				if (b === key) {
					return 1;
				}
				return 0;
			});

		if (availableTwcProducts.length === twcProducts.length) {
			return { isTwcPreselected: true, twcProducts: availableTwcProducts };
		}
	}

	return { isTwcPreselected: false, twcProducts: [] };
};
